import { render, staticRenderFns } from "./ReviewReports.vue?vue&type=template&id=f3fa58c2&scoped=true&"
import script from "./ReviewReports.vue?vue&type=script&lang=js&"
export * from "./ReviewReports.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReports.vue?vue&type=style&index=0&id=f3fa58c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fa58c2",
  null
  
)

export default component.exports